import React from "react";
import PropTypes from "prop-types";
import { TalentSimpleRoleSection } from "components/Missions/Roles";
import TALENT_SIMPLE_ROLE_SECTIONS from "constants/talentSimpleRoleSections"; // Deliberate to avoid circular dependency

/**
 * TalentSimpleRoleBoard
 *
 * The Talent Simple list view: one table per role status, each paginated on its own.
 *
 * @param {Object} filters     Merged into every section alongside that section's own states
 * @param {Object} actionBars  Section heading actions, keyed by section key
 */
const TalentSimpleRoleBoard = ({ filters, actionBars = {}, ...props }) => (
  <>
    {TALENT_SIMPLE_ROLE_SECTIONS.map(({ key, states, ...rest }) => (
      <TalentSimpleRoleSection
        key={key}
        filters={{ ...filters, states }}
        actionBar={actionBars[key]}
        {...rest}
        {...props}
      />
    ))}
  </>
);

TalentSimpleRoleBoard.propTypes = {
  filters: PropTypes.object,
  actionBars: PropTypes.objectOf(PropTypes.element),
};

export default TalentSimpleRoleBoard;
